import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioParalisacaoConsultaListaObrasParadas: ['exercicioParalisacao'],
    limpaFiltroConsultaListaObrasParadas: [],
    receberFiltroConsultaListaObrasParadas: ['filtroRecebido'],
    setStatusConsultaListaObrasParadas: ['status'],
})

const INITIAL_STATE = {
    exercicioParalisacao: '',
    status: { label: '', value: '' },
}

const setExercicioParalisacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioParalisacao: action.exercicioParalisacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_PARALISACAO_CONSULTA_LISTA_OBRAS_PARADAS]: setExercicioParalisacao,
    [Types.LIMPA_FILTRO_CONSULTA_LISTA_OBRAS_PARADAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_LISTA_OBRAS_PARADAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_LISTA_OBRAS_PARADAS]: setStatus,
})
